<template>
  <div>
    <!-- 첫번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 산업안전보건법 상 산업재해
        </h5>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">정의 및 상황</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr>
          <td class="p-4 td-cell" >1</td>
          <td class="p-4 td-cell" >정의</td>
          <td class="p-4 td-cell" >업무로 인한 3일 이상 휴업 재해</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >응급조치</td>
          <td class="p-4 td-cell" >사고유발 행위 또는 기계 정지, 구호조치/ 119 호출 및 병원진료·이송</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >3</td>
          <td class="p-4 td-cell" >유선보고</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >4</td>
          <td class="p-4 td-cell" >산업재해조사표 작성 및 제출</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청(산업재해 : 1개월 이내)</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >5</td>
          <td class="p-4 td-cell" >사고원인조사 및 대책수립</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청(산업재해 : 1개월 이내)</td>
        </tr>
      </table>
    </vs-row>

    <!-- 두번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 중대재해처벌법 상 중대산업재해
        </h5>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">정의 및 상황</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr>
          <td class="p-4 td-cell" >1</td>
          <td class="p-4 td-cell" >정의</td>
          <td class="p-4 td-cell" >(1) 사망자 1명 이상<br/>(2) 3개월 이상 부상자<br/>(3) 부상자 또는 직업성 질병 동시 10명 이상</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >응급조치</td>
          <td class="p-4 td-cell" >필요시 119 호출 및 병원진료·이송</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >3</td>
          <td class="p-4 td-cell" >작업중지 조치</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >4</td>
          <td class="p-4 td-cell" >(필요시) 초기대응 및 대피</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >5</td>
          <td class="p-4 td-cell" >유선보고</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >6</td>
          <td class="p-4 td-cell" >현장보존</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >산업재해조사표 작성 및 제출</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청(중대재해 : 즉시)</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >사고원인조사 및 대책수립</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청(중대재해 : 즉시)</td>
        </tr>
      </table>
    </vs-row>

    <!-- 세번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 중대재해처벌법 상 중대시민재해
        </h5>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">정의 및 상황</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr>
          <td class="p-4 td-cell" >1</td>
          <td class="p-4 td-cell" >정의</td>
          <td class="p-4 td-cell" >(1) 사망자 1명 이상<br/>(2) 3개월 이상 부상자<br/>(3) 부상자 또는 직업성 질병 동시 10명 이상</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >응급조치</td>
          <td class="p-4 td-cell" >필요시 119 호출 및 병원진료·이송</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >3</td>
          <td class="p-4 td-cell" >작업중지 조치</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >4</td>
          <td class="p-4 td-cell" >(필요시) 초기대응 및 대피</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >5</td>
          <td class="p-4 td-cell" >유선보고</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >6</td>
          <td class="p-4 td-cell" >현장보존</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >산업재해조사표 작성 및 제출</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청(중대재해 : 즉시)</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >사고원인조사 및 대책수립</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청(중대재해 : 즉시)</td>
        </tr>
      </table>
    </vs-row>

    <!-- 네번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 산업안전보건법 상 중대재해
        </h5>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">정의 및 상황</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr>
          <td class="p-4 td-cell" >1</td>
          <td class="p-4 td-cell" >정의</td>
          <td class="p-4 td-cell" >(1) 사망자 1명 이상<br/>(2) 3개월 이상 부상자<br/>(3) 부상자 또는 직업성 질병 동시 10명 이상</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >응급조치</td>
          <td class="p-4 td-cell" >필요시 119 호출 및 병원진료·이송</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >3</td>
          <td class="p-4 td-cell" >작업중지 조치</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >4</td>
          <td class="p-4 td-cell" >(필요시) 초기대응 및 대피</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >5</td>
          <td class="p-4 td-cell" >유선보고</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >6</td>
          <td class="p-4 td-cell" >현장보존</td>
          <td class="p-4 td-cell" ></td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >산업재해조사표 작성 및 제출</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청(중대재해 : 즉시)</td>
        </tr>
        <tr>
          <td class="p-4 td-cell" >2</td>
          <td class="p-4 td-cell" >사고원인조사 및 대책수립</td>
          <td class="p-4 td-cell" >중대산업재해 전담조직, 현장별 주관부서, 고용노동지청(중대재해 : 즉시)</td>
        </tr>
      </table>
    </vs-row>
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'

export default {
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
      }
    },
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      form: {},
    }
  },
}
</script>

<style scoped>
.table-wrap {
  width: 100%;
  border-spacing: 0;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}

.th-cell {
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.th-cell:nth-child(1) {
  max-width: 130px;
  width: 130px;
}

.th-cell:nth-child(2) {
  max-width: 390px;
  width: 390px;
}

.td-cell {
  font-weight: 500;
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd
}
.td-cell:nth-child(1) {
  text-align: center;
}
</style>
